import { useState, useEffect } from "react";
import YearMonthNavigator from "../components/molecules/YearMonthNavigator";
import AllShopsCsvDownload from "../components/molecules/AllShopsCsvDownload";
import AllShopsTreeView from "../components/organisms/AllShopsTreeView";
import { fetchRegiInfo, fetchAllShopsMonthlyReports } from "../services/dailyReportService";

// 日本時間の現在年月を YYYYMM 形式で返す
const getJapanYearMonth = () => {
  const jst = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Tokyo" }),
  );
  return `${jst.getFullYear()}${String(jst.getMonth() + 1).padStart(2, "0")}`;
};

/**
 * OfficeInputPage - 全店舗データ管理画面
 *
 * 年月を切り替えると自動でデータを再取得する（MonthlyDataPage と同じパターン）。
 * データ取得中は「読み込み中...」を表示し、完了後にツリービューを表示する。
 */
function OfficeInputPage() {
  const [yearMonth, setYearMonth] = useState(getJapanYearMonth);
  const [regiInfo, setRegiInfo] = useState([]);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  // yearMonth が変わるたびに全店舗データを再取得する
  useEffect(() => {
    setLoading(true);
    setErrorMessage(null);
    setReports([]);
    Promise.all([fetchRegiInfo(), fetchAllShopsMonthlyReports(yearMonth)])
      .then(([regi, rpt]) => {
        setRegiInfo(regi);
        setReports(rpt);
      })
      .catch((err) => {
        console.error("全店舗データ取得失敗:", err);
        setErrorMessage(`データ取得に失敗しました: ${err.message}`);
      })
      .finally(() => setLoading(false));
  }, [yearMonth]);

  return (
    <div className="p-6">
      {/* ヘッダー: 年月ナビゲーター + ZIP ダウンロードボタン */}
      <div className="flex items-center gap-4 mb-6">
        <YearMonthNavigator yearMonth={yearMonth} onChange={setYearMonth} />
        <AllShopsCsvDownload
          regiInfo={regiInfo}
          reports={reports}
          yearMonth={yearMonth}
          disabled={loading || reports.length === 0}
        />
      </div>

      {loading && <p className="text-gray-400 text-base">読み込み中...</p>}
      {errorMessage && <p className="text-red-600 text-sm">{errorMessage}</p>}

      {!loading && !errorMessage && regiInfo.length > 0 && (
        <AllShopsTreeView
          regiInfo={regiInfo}
          reports={reports}
          yearMonth={yearMonth}
        />
      )}
    </div>
  );
}

export default OfficeInputPage;
